import { render } from "./doctorComponent.vue?vue&type=template&id=0b6b8ead&scoped=true"
import script from "./doctorComponent.vue?vue&type=script&lang=js"
export * from "./doctorComponent.vue?vue&type=script&lang=js"

import "./doctorComponent.vue?vue&type=style&index=0&id=0b6b8ead&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b6b8ead"]])

export default __exports__